// extracted by mini-css-extract-plugin
export default {"wrapper":"DropDownMenu_wrapper__HHez4","item":"DropDownMenu_item__Ta3Jf","icon":"DropDownMenu_icon__TFtDh"};